module.exports = __webpack_public_path__ + "static/media/111-medium volume.b167fd4c.svg";